import { MetaData } from "../interfaces/config/metaData";

/**
 * Default description used for meta data.
 *
 * @constant {string}
 */
const description = "EHR system for hospital";

/**
 * Metadata for different pages in the application.
 *
 * @type {MetaData}
 */
const metaData: MetaData = {
  home: {
    title: "Saint louis Hospital - Genio EHR",
    description,
  },
  notFound: {
    title: "Not Found | Saint louis Hospital - Genio EHR",
    description,
  },
};

export default metaData;
